export const messages = {
  en: {
    sso: {
      noTokenError: 'Token not included, please contact system administrator',
      noTargetUrlError: 'TargetUrl not included or not encoded with encodeURIComponent'
    }
  },
  zh: {
    sso: {
      noTokenError: '未包含token，请联系系统管理员',
      noTargetUrlError: '未包含targetUrl 或者未用 targetUrl 未用encodeURIComponent 编码'
    }
  }
}